import { render, staticRenderFns } from "./PromotionLocations.vue?vue&type=template&id=370fa0fb&scoped=true&"
import script from "./PromotionLocations.vue?vue&type=script&lang=ts&"
export * from "./PromotionLocations.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionLocations.vue?vue&type=style&index=0&id=370fa0fb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370fa0fb",
  null
  
)

export default component.exports